import { render, staticRenderFns } from "./tables copy.vue?vue&type=template&id=2368f81e&"
import script from "./tables copy.vue?vue&type=script&lang=js&"
export * from "./tables copy.vue?vue&type=script&lang=js&"
import style0 from "./tables copy.vue?vue&type=style&index=0&id=2368f81e&prod&lang=scss&sp=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports